export default "__VITE_ASSET__028qyHkv__"